import React from 'react';
import './System.css';
import Panel from '../../assets/panel.svg';
import Inversor from '../../assets/inversor.svg';
import Casa from '../../assets/casaS.avif';
import Red from '../../assets/Red.svg';
import Medidor from '../../assets/Medidor.svg';

const System = () => {
    return (
        <section id="System">
            <div>
               
                    <h1>
                        ¿Como funciona un <span className="highlight">Sistema Fotovoltaico</span> de inyección a la red?
                    </h1>
               
                <div className='containerS'>
                <div className="info-box">
                    

                     <div className="bullet">1</div>

                <p>Son dispositivos que capturan la luz del sol y la convierten en electricidad. Están compuestos por celdas fotovoltaicas que generan corriente continua cuando reciben la radiación solar.</p>
                    <div className='image-container'>
                    
                        <img src={Panel} alt="Paneles solares" style={{ width: '100px', height: '100px' }} />
                        <h2>Paneles <br/> solares</h2>
                        </div>
                       
                    </div>
                    <div className="info-box">
                    <div className="bullet">2</div>
                    <div className='image-container'>
                    
                        <img src={Inversor} alt="Inversor" style={{ width: '100px', height: '80px' }} />
                        <h2>Inversor</h2>
                        </div>
                        <p>Convierte la electricidad que generan los paneles solares (corriente continua) en electricidad del tipo que usamos en casa (corriente alterna).</p>
                    </div>
                    <div className="info-box">
                    <div className="bullet">3</div>
                    <p>Representa el lugar donde se consume la electricidad generada por los paneles solares. La energía solar puede utilizarse para alimentar los aparatos eléctricos y reducir la dependencia de la red eléctrica.</p>
                    <div className='image-container'>
                    
                        <img src={Casa} alt="Inversor" style={{ width: '100px', height: '100px' }} />
                        <h2>Casa</h2>
                    </div>
                       
                    </div>
                    <div className="info-box">
                    <div className="bullet">4</div>
                    <div className='image-container'>
                    
                        <img src={Medidor} alt="Inversor"  />
                        <h2>Medidor <br/> Bidireccional</h2>
                    </div>
                        <p>Este dispositivo mide tanto la energía de la red eléctrica como la que devuelves a ella. Si produces más energía de la que usas, el medidor registra el excedente, lo que puede generar créditos con compensaciones.</p>
                    </div>

                    <div className="info-box" style={{ flexDirection: 'column', alignItems:'center'}}>
                    <div className="bullet">5</div>
                    <div className='image-container'  >
                               
                        <img src={Red} alt="Inversor" style={{ width: '100px', height: '100px'}}/>
                        <h2>Red Electrica</h2>
                    </div>
                    <p>Es la infraestructura que distribuye la electricidad a los hogares y empresas. En el contexto de un sistema solar, permite que la energía excedente generada se envie de vuelta a la red y que puedas acceder a energia de la red cuando la producción solar no es suficiente</p>
                   
                       
                    </div>
                </div>
            </div>
        </section>
    );
};

export default System;
